import { layoutColors } from '../layoutColors';

export type TrussEnvelopeStyle = 'normal' | 'faded' | 'emphasised' | 'highlighted';

export function getEnvelopeColor(style: TrussEnvelopeStyle) {
  return layoutColors.trussEnvelopes[style].line;
}

export function getOverhangEnvelopeSegmentColor(style: TrussEnvelopeStyle) {
  return layoutColors.trussEnvelopes[style].overhang;
}
